module.exports = __webpack_public_path__ + "img/vk_wh.0f164708.svg";